export const OPERATIONS_WITHOUT_VALUE = [
  'isempty',
  'isnotempty',
  'Change',
  'custom',
  'israelID',
  'usssn',
  'numbersonly',
  'alfaonly',
  'alfanumeric',
  'checked',
  'notChecked',
  'geolocation',
]
